import React from "react"
import {sortBy} from 'lodash'
import { Form, Modal, Button, FormGroup, ControlLabel, FormControl } from "react-bootstrap"

import * as collaboratorService from "../../../services/collaborator-service"
import * as unitService from '../../../services/organizational-units-service'
import * as locationService from '../../../services/location-service'

import { handleKeyPress } from '../../../utils'
import Dropdown from '../../../components/Dropdown'

const emailRegex = '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'

export default class CollaboratorModal extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.handlePost = this.handlePost.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleLocationChange = this.handleLocationChange.bind(this)
    this.handleUnitChange = this.handleUnitChange.bind(this)
    this.getUnitsForLocation = this.getUnitsForLocation.bind(this)

    this.state = {
      units: [],
      locations: [],
      collaborator: {},
      message: '',
      location: undefined,
      unit: undefined
    }
  }

  handleShow() {
    locationService.getLocations().then(locations => this.setState({ locations: locations, show: true }))

    if (this.props.id) {
      collaboratorService.getCollaborator(this.props.id).then(collaborator => {
        this.setState({collaborator})
        
        locationService.getLocationById(collaborator.locationId).then(location => this.setState({ location }))
        unitService.getUnitsByLocation(collaborator.locationId).then(units => this.setState({units}))
        unitService.getUnitById(collaborator.organizationalUnitId).then(unit => this.setState({ unit }))
      })
    }
  }

  handleHide() {
    this.setState({ show: false, collaborator: {}, location: undefined, unit: undefined })
  }

  handlePost() {
    if (this.validate()) {
      const collaborator = this.state.collaborator
      collaboratorService
        .upsertCollaborator(collaborator).then(() => {
          this.handleHide()
          this.props.reload()
          this.setState({message: ''})
        }).catch(error => {this.setState({message: 'Opslaan mislukt. Mogelijk bestaat deze medewerker al.'})})
    }
  }

  handleChange(e) {
    const key = e.target.id
    let collaborator = this.state.collaborator
    collaborator[key] = e.target.value
    this.setState({collaborator})
  }

  validate() {
    const { firstName, lastName, email, organizationalUnitId } = this.state.collaborator
    const isEmailValid = new RegExp(emailRegex).test(email)
    return ( isEmailValid && firstName && lastName && organizationalUnitId )
  }

  getUnitsForLocation() {
    if (this.state.location) {
      unitService.getUnitsByLocation(this.state.location.id)
        .then(units => this.setState({ units: units, unit: undefined }))
        .catch(() => this.setState({ units: [], unit: undefined }))
    }
  }

  handleLocationChange(e) {
    this.setState({location: e}, () => this.getUnitsForLocation())
  }

  handleUnitChange(unit) {
    let collaborator = this.state.collaborator
    collaborator.organizationalUnitId = unit.id
    collaborator.organizationalUnitName = unit.name
    this.setState({collaborator, unit})
  }


  render() {
    const { locations, location, units, unit, collaborator, message } = this.state
    const { firstName, prefix, lastName, email } = collaborator
    const { title, textbt, modalbttext } = this.props

    return (
      <div>
        <Button
          bsStyle="primary"
          className="edit-entry action-btn"
          onClick={this.handleShow}
        >
          {textbt}
        </Button>

        <Modal
          {...this.props}
          show={this.state.show}
          onHide={this.handleHide}
          onKeyPress={(e) => handleKeyPress(e, this.handlePost)}
          dialogClassName="custom-modal modal-new-employee"
          backdrop={false}>

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
              {title}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {message && <div className='error'>{message}</div>}
            <p>{this.props.text}</p>

            <Form>
              <FormGroup controlId="firstName">
                <ControlLabel>Voornaam *</ControlLabel>{' '}
                <FormControl onChange={this.handleChange} type="text" value={firstName} />
              </FormGroup>
              <FormGroup controlId="prefix">
                <ControlLabel>Tussenvoegsel</ControlLabel>{' '}
                <FormControl type="text" onChange={this.handleChange} value={prefix} />
              </FormGroup>{' '}
              <FormGroup controlId="lastName">
                <ControlLabel>Achternaam *</ControlLabel>{' '}
                <FormControl type="text" onChange={this.handleChange} value={lastName} />
              </FormGroup>{' '}
              <FormGroup controlId="email">
                <ControlLabel>E-mail *</ControlLabel>{' '}
                <FormControl type="email" onChange={this.handleChange} value={email} />
              </FormGroup>{' '}

              <FormGroup className="has-dropdown">
                <ControlLabel>Locatie *</ControlLabel>{' '}
                <Dropdown
                  dlClassNames='form-control'
                  controlWidth={2}
                  value={location}
                  data={sortBy(locations, "name")}
                  id='location_selector'
                  textField='name'
                  onChange={(e) => this.handleLocationChange(e)} />
              </FormGroup>
              
              <FormGroup className="has-dropdown">
                <ControlLabel>Organisatorische eenheid *</ControlLabel>{' '}
                <Dropdown
                  dlClassNames='form-control'
                  controlWidth={2}
                  value={unit}
                  data={sortBy(units, "name")}
                  id='unit_selector'
                  textField='name'
                  onChange={(e) => this.handleUnitChange(e)} />
              </FormGroup>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.handlePost} disabled={!this.validate()}>
              {modalbttext}
            </Button>
            <Button onClick={this.handleHide}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Collaborators/modals/CollaboratorModal.js